export enum Breakpoint {
  XXSmall = 400,
  XSmall = 600,
  Small = 960,
  Medium = 1264,
  Large = 1500,
  XLarge = 1920,
}
